var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 507,
    viewBox: "0 0 512 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427.847 0H83.2174C37.2577 0 0 37.2262 0 83.1471V423.05C0 468.971 37.2577 506.197 83.2174 506.197H427.847C473.807 506.197 511.064 468.971 511.064 423.05V83.1471C511.064 37.2262 473.807 0 427.847 0Z",
    fill: "#00A7E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.65 145.15C202.328 138.365 193.354 136.376 186.57 140.698C179.786 145.02 177.796 153.994 182.118 160.778L232.91 240.505C235.059 243.878 234.057 248.395 230.684 250.544C227.311 252.693 222.793 251.692 220.644 248.319L177.667 180.858C173.345 174.073 164.372 172.084 157.587 176.406C150.803 180.728 148.813 189.701 153.136 196.486L219.555 300.744C219.841 301.192 227.699 313.527 231.234 319.035C231.759 319.854 230.82 321.254 229.864 321.075L195.915 314.726C186.071 312.807 176.52 319.215 174.562 329.084C172.605 338.953 179.051 348.479 188.92 350.437L258.132 364.003C284.688 369.232 312.243 364.018 335.088 349.464L342.447 344.776C379.704 321.04 390.422 271.211 354.477 214.789L303.686 135.062C299.363 128.278 290.39 126.289 283.606 130.611C276.822 134.933 274.832 143.906 279.154 150.69L306.504 193.62C308.652 196.993 307.651 201.511 304.278 203.66C300.905 205.809 296.387 204.807 294.238 201.434L251.261 133.973C246.938 127.189 237.965 125.2 231.181 129.522C224.397 133.844 222.407 142.817 226.729 149.601L269.707 217.062C271.856 220.435 270.854 224.953 267.481 227.102C264.108 229.251 259.59 228.249 257.441 224.876L206.65 145.15Z",
    fill: "#FDF5BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.503 145.481C373.454 155.813 391.406 186.157 390.105 207.452",
    stroke: "#FDF5BF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.547 104.352C414.357 112.305 440.49 204.336 425.492 218.425",
    stroke: "#FDF5BF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.497 333.753C137.546 323.422 119.594 293.077 120.895 271.782",
    stroke: "#FDF5BF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.453 374.883C96.6429 366.929 70.5105 274.898 85.5083 260.809",
    stroke: "#FDF5BF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.00766c778a1b7b8b37a839add6ca2453.svg";
export { ForwardRef as ReactComponent };